import {React, useEffect, useState} from "react";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function CheckoutFailedPage() {
  const windowSize = useWindowSize();
  const verticalSpacer = (height) => <div style={{ height: `${height}px` }} />;
  const horizontalSpacer = (width) => <div style={{ width: `${width}px` }} />;

  return(
    <div>
      <div className="CartPageContainer">
        <div>
          <p style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#333333",
            textAlign: "center",
            marginBottom: "3px",
            alignItems: "center",
          }}>
            Payment Failed
          </p>
          {verticalSpacer(20)}
          
          <div style={{
            background: "rgba(166, 158, 158, 0.9)",
            borderRadius: 20,
            width: "90%",
            padding: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            {/* Failed Icon */}
            <div style={{
              width: '60px',
              height: '60px',
              background: '#e61d0f',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <svg 
                width="32" 
                height="32" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="white" 
                strokeWidth="3" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>

            <p style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333333",
              textAlign: "center",
              marginBottom: "10px",
            }}>
              Your payment could not be processed
            </p>

            <p style={{
              fontSize: "14px",
              fontWeight: "normal",
              color: "#555555",
              textAlign: "center",
              marginTop: "10px",
            }}>
              Please check your payment details and try again
            </p>
          </div>

          {verticalSpacer(20)}

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '15px'
          }}>
            <button
              onClick={() => window.location.href = '/CartPage'}
              style={{
                background: "#333333",
                color: "white",
                border: "none",
                borderRadius: 10,
                padding: "12px 40px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                background: "transparent",
                color: "#333333",
                border: "2px solid #333333",
                borderRadius: 10,
                padding: "12px 40px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
      {verticalSpacer((windowSize.height * 0.7))}
    </div>
  );
}

export default CheckoutFailedPage;